export const forentoAiBetaCreditGrant = 150
export const forentoAiBetaPoolSize = 6_000

const claimIntervalMilliseconds = 10_000
const refillDurationMilliseconds = 5 * 60_000
const availableSpots = forentoAiBetaPoolSize / forentoAiBetaCreditGrant
const availableDurationMilliseconds = availableSpots * claimIntervalMilliseconds
const cycleDurationMilliseconds = availableDurationMilliseconds + refillDurationMilliseconds
const launchDateMilliseconds = Date.UTC(2026, 6, 14)

export type ForentoAiBetaPoolState =
	| { status: "available"; creditsLeft: number; spotsClaimed: number; totalSpots: number }
	| { status: "refilling"; creditsLeft: 0; spotsClaimed: number; totalSpots: number; refillSeconds: number }

export function getForentoAiBetaPoolState(now = Date.now()): ForentoAiBetaPoolState {
	const elapsedSinceLaunch = now - launchDateMilliseconds
	const elapsedInCycle =
		((elapsedSinceLaunch % cycleDurationMilliseconds) + cycleDurationMilliseconds) % cycleDurationMilliseconds

	if (elapsedInCycle < availableDurationMilliseconds) {
		const spotsClaimed = Math.floor(elapsedInCycle / claimIntervalMilliseconds)
		return {
			status: "available",
			creditsLeft: forentoAiBetaPoolSize - spotsClaimed * forentoAiBetaCreditGrant,
			spotsClaimed,
			totalSpots: availableSpots,
		}
	}

	return {
		status: "refilling",
		creditsLeft: 0,
		spotsClaimed: availableSpots,
		totalSpots: availableSpots,
		refillSeconds: Math.ceil((cycleDurationMilliseconds - elapsedInCycle) / 1_000),
	}
}
